<template>
  <div>

    <fieldset>

      <h2>
        Foto’s toevoegen
      </h2>
      <p>Upload hieronder de drie foto’s die je genomen hebt.</p>

			<ImageInput v-model="localMeasurement.photoForward" label="Rechtvooruit" name="photo_1"></ImageInput>
			<ImageInput v-model="localMeasurement.photoShore" label="Langs de oever" name="photo_2"></ImageInput>
			<ImageInput v-model="localMeasurement.photoAbove" label="Boven op het water" name="photo_3"></ImageInput>

    </fieldset>
    <nav>
      <button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
      <button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">Volgende</button>
    </nav>
  </div>
</template>

<script>
import ImageInput from "./components/ImageInput.vue";
import FormStep from "./FormStep.vue";

export default {
  name: "FormStep6",
	components: {ImageInput},
  mixins: [FormStep],
  data(){
    return {
      fieldRequirements: {
        photoForward: ['required'],
        photoShore: ['required'],
        photoAbove: ['required'],
      }
    }
  },
}
</script>

<style scoped>
</style>
